import { Reducer } from "redux";

import { RelationshipMasterResponse } from "../models/Api/MemberDetails";
import { RelationshipDispatchTypes } from "../models/DispatchTypes/MemberDetails";
import { RelationshipActionDispatchTypes } from "../constants/MemberDetails";

export const initialState: RelationshipMasterResponse = {
  loading: false,
  response: [],
};

const RelationshipReducer: Reducer<
  RelationshipMasterResponse,
  RelationshipDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case RelationshipActionDispatchTypes.RELATIONSHIP_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case RelationshipActionDispatchTypes.RELATIONSHIP_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default RelationshipReducer;
